import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-inquilino',
  templateUrl: './dialog-create-inquilino.component.html',
  styleUrls: ['./dialog-create-inquilino.component.css']
})
export class DialogCreateInquilinoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
